<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />
    <div class="chart-page">
      <div class="card search-card">
        <div class="card-body">
          <div class="form-row">
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">主要經驗分類</label>
                <el-select
                  class="w-100"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  v-model="search.ResumeTagGuids"
                >
                  <el-option
                    v-for="item in resumeTagList"
                    :key="item.Guid"
                    :label="item.Name"
                    :value="item.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">預約面談日期(起)</label>
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇"
                  v-model="search.InterviewDateStart"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">預約面談日期(迄)</label>
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇"
                  v-model="search.InterviewDateEnd"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">職缺名稱</label>
                <el-select
                  class="w-100"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  placeholder="請選擇"
                  v-model="search.ManpowerDemandNos"
                >
                  <el-option
                    v-for="item in manpowerDemandNoList"
                    :key="item.ManpowerDemandNo"
                    :label="`${item.ManpowerDemandNo}-${item.ManpowerDemandName}`"
                    :value="item.ManpowerDemandNo"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">面談結果</label>
                <el-select
                  class="w-100"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  placeholder="請選擇"
                  v-model="search.InterviewApprovalResults"
                >
                  <el-option label="錄取" value="錄取"></el-option>
                  <el-option label="考慮中" value="考慮中"></el-option>
                  <el-option label="複試" value="複試"></el-option>
                  <el-option label="不錄取" value="不錄取"> </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">HCPInfo所在廠區</label>
                <el-select
                  class="w-100"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  placeholder="請選擇"
                  v-model="search.EmployeePlantGuids"
                >
                  <el-option
                    v-for="item in employeePlantList"
                    :key="item.Guid"
                    :label="item.Name"
                    :value="item.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">班別</label>
                <el-select
                  class="w-100"
                  filterable
                  multiple
                  collapse-tags
                  clearable
                  placeholder="請選擇"
                  v-model="search.WorkShiftTypeGuids"
                >
                  <el-option
                    v-for="item in workShiftList"
                    :key="item.Guid"
                    :label="item.Name"
                    :value="item.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">預計報到日期(起)</label>
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇"
                  v-model="search.OnBoardDateStart"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">預約報到日期(迄)</label>
                <el-date-picker
                  class="w-100"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="請選擇"
                  v-model="search.OnBoardDateEnd"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">報到結果</label>
                <el-select
                  class="w-100"
                  clearable
                  multiple
                  collapse-tags
                  placeholder="請選擇"
                  v-model="search.OnBoardStatuses"
                >
                  <el-option label="簽核中" :value="-999"></el-option>
                  <el-option label="待報到" :value="0"></el-option>
                  <el-option label="完成報到" :value="1"></el-option>
                  <el-option label="取消報到" :value="-99"></el-option>
                  <el-option label="延期報到" :value="-1"></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">組織代碼</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="search.EmployeeGroupCodeKeyword"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <button
                style="margin-top: 30px; margin-left: 10px"
                class="btn btn-primary"
                @click="
                  getDetail({
                    page: 1,
                    per_page: pageSize,
                  })
                "
              >
                查詢
              </button>
              <button
                style="margin-top: 30px; margin-left: 10px"
                class="btn btn-info"
                @click="reportDownload"
              >
                匯出報表
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                style="margin-top: 30px; margin-left: 10px"
                @click="search = {}"
              >
                清除
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap" style="padding: 20px">
      <el-table :data="rows" style="width: 100%;" class="elTable" height="500px" @sort-change="sortChange">
        <template slot="empty">
          <span>暫無數據</span>
        </template>
        
        <el-table-column prop="Name" label="姓名" fixed="left" sortable="custom">
        </el-table-column>
        <el-table-column prop="Sex" label="性別" fixed="left" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="IdNo"
          label="身份證字號"
          fixed="left"
          width="120" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="MobilePhone"
          label="手機"
          fixed="left"
          width="120" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="Birthday" label="生日" width="100" sortable="custom">
          <template slot-scope="scope">
            <span>{{ $common.dateFormatter(scope.row.Birthday) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Age" label="年齡" sortable="custom"> </el-table-column>
        <el-table-column prop="Email" label="Email" width="200" sortable="custom">
        </el-table-column>
        <el-table-column prop="Address" label="戶籍地址" width="200" sortable="custom">
        </el-table-column>
        <el-table-column prop="ContactAddress" label="通訊地址" width="200" sortable="custom">
        </el-table-column>
        <el-table-column prop="Nationality" label="國籍" sortable="custom"> </el-table-column>
        <el-table-column prop="HasDisabilityCardDesc" label="身障證明" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="EducationcategoryTop" label="學位" sortable="custom">
        </el-table-column>
        <el-table-column prop="SchoolTop" label="學校" sortable="custom"> </el-table-column>
        <el-table-column prop="MajorNameTop" label="科系" sortable="custom"> </el-table-column>
        <el-table-column prop="ResumeTagTop" label="主要經驗分類" width="130" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="ResumeTagSecond"
          label="次要經驗分類"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="ResumeFreeTags"
          label="Hashtag(其他經驗)"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="TotalSeniority" label="總年資" sortable="custom">
        </el-table-column>
        <el-table-column prop="WorkExperience" label="工作經歷" width="200" sortable="custom">
        </el-table-column>
        <el-table-column prop="Recommender" label="推薦人" width="130" sortable="custom"> </el-table-column>
        <el-table-column prop="ContactStatus" label="聯繫狀況-主因" sortable="custom">
        </el-table-column>
        <el-table-column prop="ContactStatusSecond" label="聯繫狀況-二階原因" sortable="custom">
        </el-table-column>
        <el-table-column prop="ContactRemark" label="聯繫狀況備註" width="110" sortable="custom">
        </el-table-column>
        <el-table-column prop="InterviewDate" label="預約面談日期" width="100" sortable="custom">
          <template slot-scope="scope">
            <span>{{ $common.dateTimeFormatter(scope.row.InterviewDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="InterviewDateActual" label="實際面談日期" width="100" sortable="custom">
          <template slot-scope="scope">
            <span>{{
              $common.dateTimeFormatter(scope.row.InterviewDateActual)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="InterviewNotArrivedReason"
          label="預約未到原因分類" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="ManpowerDemandName" label="應徵職務" width="200" sortable="custom">
        </el-table-column>
        <el-table-column prop="PersonInfoWorkShiftTypes" label="應徵班別" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="InterviewApprovalResult" label="面談結果" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="InterviewApprovedTime" label="面談評估完成時間" sortable="custom">
          <template slot-scope="scope">
            <span>{{
              $common.dateTimeFormatter(scope.row.InterviewApprovedTime)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="HCPEmployeePlant" label="錄取廠區" sortable="custom">
        </el-table-column>
        <el-table-column prop="HCPEmployeeDepartment" label="錄取部門" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="HCPEmployeeStation" label="錄取站點" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="HCPWorkShiftType" label="錄取班別" width="130" sortable="custom">
        </el-table-column>
        <el-table-column prop="HCPAppointmentDepartment" label="任用部門" width="130" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="NoHiredReasonSupervisor"
          label="單位主管面談說明"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="NoHiredReasonHR" label="HR面談說明" width="200" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="NoHiredReasonSupervisorRemark"
          label="單位主管未錄取Remark匯出"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="NoHiredReasonHRRemark"
          label="HR未錄取Remark匯出"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="InterviewSupervisorEmpNo"
          label="單位面談主管工號" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="InterviewSupervisor"
          label="單位面談主管"
          width="120" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="InterviewHR" label="HR面談者" width="140" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="InterviewSupervisorPersonalRemark"
          label="個人備註(主管Remark)"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="InterviewHRPersonalRemark"
          label="個人備註(HR Remark)"
          width="200" sortable="custom"
        >
        </el-table-column>
        <el-table-column prop="OnBoardTime" label="預計報到日期" width="120" sortable="custom">
          <template slot-scope="scope">
            <span>{{ $common.dateFormatter(scope.row.OnBoardTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OnBoardTimeActual" label="實際報到日期" width="120" sortable="custom">
          <template slot-scope="scope">
            <span>{{
              $common.dateFormatter(scope.row.OnBoardTimeActual)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OnBoard" label="報到結果" sortable="custom"> </el-table-column>
        <el-table-column prop="EmployeeNo" label="工號" sortable="custom"> </el-table-column>
        <el-table-column prop="NotArrivedCategory" label="未報到主因" sortable="custom">
        </el-table-column>
        <el-table-column prop="NotArrivedCategorySecond" label="未報到原因" sortable="custom">
        </el-table-column>
        <el-table-column prop="OnBoardRemark" label="未報到備註" sortable="custom">
        </el-table-column>
        <el-table-column prop="SourceCategory" label="來源管道" sortable="custom">
        </el-table-column>
        <el-table-column prop="SourceCategorySecond" label="來源管道(二階段)" sortable="custom">
        </el-table-column>
        <el-table-column prop="OnBoardDataCompleted" label="報到資料已繳交完成" width="140" sortable="custom">
          <template slot-scope="scope">
            <span>{{ scope.row.OnBoardDataCompleted ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EnglishName" label="英文名字" width="170" sortable="custom">
        </el-table-column>
        <el-table-column prop="HCPEmployeeGroupCode" label="組織代碼" sortable="custom">
        </el-table-column>
        <el-table-column prop="HcpIsNeedTraining" label="是否進訓" sortable="custom">
          <template slot-scope="scope">
            <span v-if="scope.row.HcpIsNeedTraining === true">是</span>
            <span v-else-if="scope.row.HcpIsNeedTraining === false">否</span>
            <span v-else>{{ scope.row.HcpIsNeedTraining }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="HcpRemark" label="HCP 備註" width="120" sortable="custom">
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="sizes, prev, pager, next"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>

<script>
import { config } from "@/components/back/table_config.js";

export default {
  name: "LoginRecord",

  data() {
    return {
      resumeTagList: null,
      manpowerDemandNoList: null,
      employeePlantList: null,
      workShiftList: null,
      search: {},

      rows: [],

      // 分頁
      tableData: [],
      totalData: 0,
      currentPage: 1,
      pageSize: 5,

      config: {
        ...config,
        server_mode: true,
      },
      
      currentSort:{
        prop:null,
        order:null
      }
    };
  },

  methods: {
    async getCommonOption() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);

      await vm.$http
        .all([
          vm.$api.opening.getOpening(), //取得需求單
          vm.$api.employeePlant.getPlant(), //取得所在廠區
          vm.$api.workShift.getWorkShift(), // 取得 班別
          vm.$api.resumeTag.getResumeTag(), // 取得經驗分類選項
        ])
        .then(
          vm.$http.spread(
            (
              manpowerDemandNoList,
              employeePlantList,
              workShiftList,
              resumeTagList
            ) => {
              vm.manpowerDemandNoList = manpowerDemandNoList.data;
              vm.employeePlantList = employeePlantList.data;
              vm.workShiftList = workShiftList.data;
              vm.resumeTagList = resumeTagList.data;
            }
          )
        );

      vm.$store.dispatch("updateLoading", false);
    },

    // 登入紀錄詳細資料 API
    getDetail({ page, per_page }) {
      const vm = this;
      const api = `${window.endpoints.api}/Report/RecruitReport/Detail`;

      const data = {
        ...vm.search,
        Page: page,
        PerPage: per_page,
        OrderProp:vm.currentSort.prop,
        Order:vm.currentSort.order
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.rows = response.data.Datas;
            vm.totalData = response.data.Quantity;
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 匯出
    reportDownload() {
      const vm = this;
      const api = `${window.endpoints.api}/Report/RecruitReport/Export`;

      const data = {
        ...vm.search,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http.post(api, data, { responseType: "blob" }).then((response) => {
        vm.$store.dispatch("updateLoading", false);
        let filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },

    // 一頁顯示幾筆資料
    handleSizeChange(val) {
      this.pageSize = val;
      const vm = this;
      vm.getDetail({
        page: this.currentPage,
        per_page: this.pageSize,
      });
    },

    // 換頁
    handleCurrentChange(val) {
      this.currentPage = val;
      const vm = this;
      vm.getDetail({
        page: this.currentPage,
        per_page: this.pageSize,
      });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    sortChange(column) {
      const vm = this;
      
      vm.currentSort={...column};
      
      vm.getDetail({
        page: vm.currentPage,
        per_page: vm.pageSize,
      });
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getCommonOption();
  },
};
</script>
<style lang="scss">
/deep/ .el-table {
  .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
